export default __webpack_public_path__ + "static/media/maquina_ancho-1.2798b2c9.png";